<div>
  <form [formGroup]="form">
    <div class="mb-3 row" style="margin-top: 0px;">
      <div class="uv-row">
        <span style="padding-top: 7px; margin-right: 10px; font-weight: bold; font-size: 16px;">Selected Device:</span>
        <span style="padding: 7px 3.5px 0px 3.5px; font-size: 16px; border: none; border-radius: 3px;">
          {{deviceName}}
        </span>
        <span style="width: 30px;">&nbsp;</span>
        <button type="button" pButton label="Select Device..." [disabled]="!enableSelectDevice"
        (click)="selectDevice()"></button>
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 30px;">
      <div class="uv-row">
        <span style="padding-top: 7px; margin-right: 10px; font-weight: bold; font-size: 16px;">VLAN:</span>
        <select [formControl]="vlan" style="padding-top: 0px; padding-bottom: 0px;">
          @for (v of vlans; track v) {
            <option value="{{v.Index}}">
              {{v.DisplayNameWithIndex}}
            </option>
          }
        </select>
        <span style="width: 30px;">&nbsp;</span>
        <span style="padding-top: 7px; margin-right: 10px; font-weight: bold; font-size: 16px;">Voice VLAN:</span>
        <select [formControl]="voiceVlan" style="padding-top: 0px; padding-bottom: 0px;">
          @for (v of voiceVlans; track v) {
            <option value="{{v.Index}}">
              {{v.DisplayNameWithIndex}}
            </option>
          }
        </select>
        <span style="width: 30px;">&nbsp;</span>
        <button [disabled]="!enableUpdate" type="button" pButton label="Update"
        icon="fa fa-edit" (click)="update()"></button>
      </div>
    </div>

    <div class="mb-3 row" style="margin-top: 30px;">
      <fieldset>
        <legend>Current Status</legend>
      </fieldset>
    </div>
    <div class="mb-3 row" style="margin-top: 30px;">
      <bridgeport-selector [device]="device" selectionMode="multiple" [(selection)]="selectedPorts"
        [portTableHeightVh]="portTableHeightVh" [portTableHeightPx]="portTableHeightPx"
        [portTableMinHeight]="portTableMinHeight">
      </bridgeport-selector>
    </div>
    <div class="mb-3 row" style="margin-bottom: 0px;">
      <div class="uv-row">
        <button [disabled]="!enableRefresh" type="button" pButton label="Refresh"
        icon="fa fa-refresh" (click)="refresh()" title="Load current state from the device"></button>
      </div>
    </div>
  </form>

  <device-selector [header]="'Select a Device'" [(visible)]="displayDeviceSelector" [minDevices]="1" [maxDevices]="1"
    (onCancel)="onDeviceSelectorCancel()" (onOk)="onDeviceSelectorOk($event)">
  </device-selector>

</div>
